export const documentTypes = {
    VALIDATE_DOCUMENT_REQUEST: "VALIDATE_DOCUMENT_REQUEST",
    VALIDATE_DOCUMENT_SUCCESS: "VALIDATE_DOCUMENT_SUCCESS",
    VALIDATE_DOCUMENT_FAILURE: "VALIDATE_DOCUMENT_FAILURE",
};
